import { ReactNode } from 'react'

import { RowContainer } from './styles'

interface IRowProps {
  children: ReactNode
}

export function Row({ children }: IRowProps) {
  return <RowContainer>{children}</RowContainer>
}
